import { useQuery } from 'react-query';
import {
  exportBalance,
  exportClient,
  exportRegistration,
  exportSenderName,
  exportSmsUsage,
  exportTransaction,
  exportWalletBalance,
  getBalanceList,
  getClientList,
  getRegistrationList,
  getSenderNameList,
  getSmsUsageList,
  getTransactionList,
  getWalletBalanceList,
} from './actions';

export const useSenderNameList = (params) => {
  const { data: raw, isLoading } = useQuery({
    queryKey: ['get-sender-name-report', params],
    queryFn: getSenderNameList,
    retry: false,
    keepPreviousData: false,
  });

  const data = raw?.data?.data;
  const meta = raw?.data?.meta;

  return [isLoading, data, meta];
};

export const useExportSenderName = (params) => {
  const { data: raw, isLoading } = useQuery({
    queryKey: ['export-sender-names', params],
    queryFn: exportSenderName,
    retry: false,
    keepPreviousData: false,
  });

  const data = raw?.data;
  return [isLoading, data];
};

export const useSmsUsageList = (params) => {
  const { data: raw, isLoading } = useQuery({
    queryKey: ['get-sms-usage-report', params],
    queryFn: getSmsUsageList,
    retry: false,
    keepPreviousData: false,
  });

  const data = raw?.data?.data;
  const meta = raw?.data?.meta;

  return [isLoading, data, meta];
};

export const useExportSmsUsage = (params) => {
  const { data: raw, isLoading } = useQuery({
    queryKey: ['export-sms-usage', params],
    queryFn: exportSmsUsage,
    retry: false,
    keepPreviousData: false,
  });

  const data = raw?.data;
  return [isLoading, data];
};

export const useTransactionList = (params) => {
  const { data: raw, isLoading } = useQuery({
    queryKey: ['get-transaction-report', params],
    queryFn: getTransactionList,
    retry: false,
    keepPreviousData: false,
  });

  const data = raw?.data?.data;
  const meta = raw?.data?.meta;

  return [isLoading, data, meta];
};

export const useExportTransactions = (params) => {
  const { data: raw, isLoading } = useQuery({
    queryKey: ['export-transactions', params],
    queryFn: exportTransaction,
    retry: false,
    keepPreviousData: false,
  });

  const data = raw?.data;
  return [isLoading, data];
};

export const useBalanceList = (params) => {
  const { data: raw, isLoading } = useQuery({
    queryKey: ['get-balance-report', params],
    queryFn: getBalanceList,
    retry: false,
    keepPreviousData: false,
  });

  const data = raw?.data?.data;
  const meta = raw?.data?.meta;

  return [isLoading, data, meta];
};

export const useExportBalance = (params) => {
  const { data: raw, isLoading } = useQuery({
    queryKey: ['export-balance', params],
    queryFn: exportBalance,
    retry: false,
    keepPreviousData: false,
  });

  const data = raw?.data;
  return [isLoading, data];
};

export const useRegistrationList = (params) => {
  const { data: raw, isLoading } = useQuery({
    queryKey: ['get-registration-report', params],
    queryFn: getRegistrationList,
    retry: false,
    keepPreviousData: false,
  });

  const data = raw?.data?.data;
  const meta = raw?.data?.meta;

  return [isLoading, data, meta];
};

export const useExportRegistration = (params) => {
  const { data: raw, isLoading } = useQuery({
    queryKey: ['export-registration', params],
    queryFn: exportRegistration,
    retry: false,
    keepPreviousData: false,
  });

  const data = raw?.data;
  return [isLoading, data];
};

export const useClientList = (params) => {
  const { data: raw, isLoading } = useQuery({
    queryKey: ['get-client-report', params],
    queryFn: getClientList,
    retry: false,
    keepPreviousData: false,
  });

  const data = raw?.data?.data;
  const meta = raw?.data?.meta;

  return [isLoading, data, meta];
};

export const useExportClient = (params) => {
  const { data: raw, isLoading } = useQuery({
    queryKey: ['export-client', params],
    queryFn: exportClient,
    retry: false,
    keepPreviousData: false,
  });

  const data = raw?.data;
  return [isLoading, data];
};

export const useWalletBalanceList = (params) => {
  const { data: raw, isLoading } = useQuery({
    queryKey: ['get-wallet-balance-report', params],
    queryFn: getWalletBalanceList,
    retry: false,
    keepPreviousData: false,
  });

  const data = raw?.data?.data;
  const meta = raw?.data?.meta;

  return [isLoading, data, meta];
};

export const useExportWalletBalance = (params) => {
  const { data: raw, isLoading } = useQuery({
    queryKey: ['export-wallet-balance', params],
    queryFn: exportWalletBalance,
    retry: false,
    keepPreviousData: false,
  });

  const data = raw?.data;
  return [isLoading, data];
};
